import React from 'react';
import { PageLayout } from '../../Layout/PageLayout';
import { CompanyInfoForm } from './CompanyInfoForm';
import { useApi } from '../../../hooks';
import { companyService } from '../../../services';

export const CompanyInfoPage: React.FC = () => {
  const { data: company, loading, error, refetch } = useApi({
    apiCall: companyService.getCompany,
    onError: (error) => {
      console.error('Failed to load company info:', error);
    },
  });

  const handleSuccess = () => {
    refetch();
  };

  return (
    <PageLayout
      title="Company Information"
      breadcrumbs={[
        { text: 'Settings', href: '/settings' },
        { text: 'Company Information' },
      ]}
      alert={error ? { variant: 'danger', message: error } : undefined}
    >
      <CompanyInfoForm company={company || undefined} onSuccess={handleSuccess} />
    </PageLayout>
  );
}; 
